import lodash from 'lodash';
import React, { useCallback } from 'react';
import { useT } from '~app/core/BundleProvider';
import { useDispatch, useSelector } from 'react-redux';
import { actions as CanvasActions } from '~app/features/canvas';
import useGlobalHotkey from '~app/core/useGlobalHotkey';
import IconButton from '~app/features/app/components/IconButton';
import withDraggable from '~app/core/withDraggable';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

// Keyboard shortcuts draggable table
function KeyboardShortcuts({ selected }) {
  const t = useT();
  const dispatch = useDispatch();
  const showKeyboardShortcuts = useSelector(
    state => state.canvas.showKeyboardShortcuts,
  );
  const closeKeyboardShortcuts = useCallback(
    e => {
      e.stopPropagation();
      if (showKeyboardShortcuts) {
        dispatch(CanvasActions.hideKeyboardShortcuts());
      }
    },
    [dispatch, showKeyboardShortcuts],
  );
  useGlobalHotkey({
    hotkey: '', // pending assignment of shortcut key
    callback: closeKeyboardShortcuts,
    event: 'keyup',
    priority: 10,
    stop: true,
  });
  const keysInfo = [
    {
      key: t('tab-key'),
      desc: t('tab-desc'),
    },
    {
      key: t('enter-key'),
      desc: t('enter-desc'),
    },
    {
      key: t('up-arrow-key'),
      desc: t('up-arrow-desc'),
    },
    {
      key: t('down-arrow-key'),
      desc: t('down-arrow-desc'),
    },
    {
      key: t('right-arrow-key'),
      desc: t('right-arrow-desc'),
    },
    {
      key: t('left-arrow-key'),
      desc: t('left-arrow-desc'),
    },
    {
      key: t('zoom-pan-key'),
      desc: t('zoom-pan-desc'),
    },
    {
      key: t('undo-key'),
      desc: t('undo-desc'),
    },
    {
      key: t('redo-key'),
      desc: t('redo-desc'),
    },
    {
      key: t('escape-key'),
      desc: t('escape-desc'),
    },
    {
      key: t('u-key'),
      desc: t('u-desc'),
    },
    {
      key: t('s-key'),
      desc: t('s-desc'),
    },
    {
      key: t('v-key'),
      desc: t('v-desc'),
    },
    {
      key: t('f-key'),
      desc: t('f-desc'),
    },
    {
      key: t('o-key'),
      desc: t('o-desc'),
    },
    {
      key: t('i-key'),
      desc: t('i-desc'),
    },
    {
      key: t('p-key'),
      desc: t('p-desc'),
    },
    {
      key: t('n-key'),
      desc: t('n-desc'),
    },
    {
      key: t('zero-key'),
      desc: t('zero-desc'),
    },
  ];
  const keysItems = keysInfo.map((keyObj, i) => (
    <tr className="KeyboardShortcuts__body" key={`shortcuts${i}`}>
      <td className="col">{keyObj['key']}</td>
      <td className="col">{keyObj['desc']}</td>
    </tr>
  ));
  return (
    <div className={'KeyboardShortcuts__node'} tabIndex={0}>
      <div>
        <table className="KeyboardShortcuts__container">
          <caption
            className={`KeyboardShortcuts__top handle  ${
              selected ? 'selected' : ''
            }`}
          >
            <div role="heading" aria-level={5}>
              {t('keyboard-shortcuts')}
            </div>
            <ClickOrEnterDiv
              className="Close__icon"
              onTouchStart={closeKeyboardShortcuts}
              onClick={closeKeyboardShortcuts}
              ariaLabel={t('close-menu')}
              tabIndex={0}
            >
              <IconButton styleName="Popup__exit" />
            </ClickOrEnterDiv>
          </caption>
          <tr className="KeyboardShortcuts__header">
            <th className="col font-weight-normal">
              {t('keyboard-shortcuts-head')}
            </th>
            <th className="col font-weight-normal">
              {t('keyboard-shortcuts-cmd')}
            </th>
          </tr>
          {keysItems}
        </table>
      </div>
    </div>
  );
}

export default React.memo(
  withDraggable(KeyboardShortcuts, {
    draggableProps: {
      handle: '.handle',
      defaultClassName: 'KeyboardShortcuts-draggable',
    },
  }),
  lodash.isEqual,
);
